import { render, staticRenderFns } from "./SelectTuevsTempo.vue?vue&type=template&id=36650f25&scoped=true&"
import script from "./SelectTuevsTempo.vue?vue&type=script&lang=js&"
export * from "./SelectTuevsTempo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36650f25",
  null
  
)

export default component.exports